import React, { useState, useEffect } from 'react';
import { Grid, List, ListItem, Checkbox } from '@mui/material';
import '../../style/common.css';
import { useTranslation } from 'react-i18next';

const BusinessUnitLocationMapping = ({dataObj, selectedItems, setSelectedItems, bunitFilterList, businessOption, isDisabled=false, isBUser=false, page="default"}) => {
  const { t } = useTranslation('common');
  const [selectedOptions, setSelectedOptions] = useState(isBUser && page === "selfRegistration" ? [] : businessOption);
  // const [selectedOptions, setSelectedOptions] = useState(['All']);

  const [locations, setLocations] = useState([]);
  const [locationsData, setLocationsData] = useState({})

  useEffect(()=>{
    if(bunitFilterList && bunitFilterList?.status === 200){
      const dataArr = bunitFilterList?.data || []
      let locationData = {
      }
      dataArr?.forEach(input => {
          locationData[input.businessUnitName] = input.businessLocation ? input.businessLocation : input.businessUnitLocations || []
      });
      setLocationsData(locationData);
    }
    },[bunitFilterList])

    let optionList = null;
    let sortedOptionList = null;
    // if(!isBUser) {
    //    optionList = ['All', ...Object.keys(locationsData)];
    //    sortedOptionList = optionList.slice().sort((a, b) => {
    //     if (a === 'All') return -1;
    //     if (b === 'All') return 1;
    //     return a.localeCompare(b);
    //   });
    // } else {
       optionList = [...Object.keys(locationsData)];
       sortedOptionList = optionList?.slice().sort((a, b) => a?.localeCompare(b));
    // }
    
  useEffect(() => {
    if (selectedOptions?.includes('All') || selectedOptions?.length === 0) {
      const allLocations = Object.values(locationsData).flat();
      const sortedLocations = allLocations?.sort((a, b) => a?.locationName?.localeCompare(b.locationName));

      setLocations(sortedLocations);
    } else if(locationsData){
      const selectedLocations = selectedOptions?.flatMap(option => locationsData[option] || []);
      const sortedLocations = selectedLocations?.sort((a, b) => a?.locationName?.localeCompare(b.locationName));

      setLocations(sortedLocations);
    }
  }, [selectedOptions, locationsData]);

  useEffect(() => {
    if(!isBUser || page !== "selfRegistration") {
      setSelectedOptions(businessOption)
    }
  }, [businessOption.length, businessOption]);

  const getBusinessUnitId = (unitName) => {
    const foundUnit = bunitFilterList?.data?.find(unit => unit.businessUnitName === unitName);
    return foundUnit ? foundUnit.businessUnitId : null; // Return the ID or null if not found
  };

  const handleOptionClick = (option) => {
    setSelectedOptions((prevOptions) => {
      if (option === 'All') {
        // If "All" is already selected, unselect all options; otherwise, select all options
        return prevOptions?.includes('All') ? [] : sortedOptionList;
      } else {
        const updatedOptions = prevOptions?.includes(option)
          ? prevOptions.filter((o) => o !== option)
          : [...prevOptions, option];
          // if(isBUser) {
            const selectedLocations = updatedOptions?.flatMap(option => locationsData[option] || []);
            const sortedLocations = selectedLocations?.sort((a, b) => a?.locationName?.localeCompare(b.locationName));
            const businessUnitIds = updatedOptions.map(name => getBusinessUnitId(name));
            const hasSelectedItem = sortedLocations.some(location => 
              selectedItems.includes(location.id)
            );
            if(!hasSelectedItem) {
              setSelectedItems([])
            }
          // }
        // If an individual option is clicked, ensure "All" is not selected
        return updatedOptions?.includes('All') ? updatedOptions?.filter((o) => o !== 'All') : updatedOptions;
      }
    });
  };
  
  
  const handleToggleSelect = (itemId) => {
    if (selectedItems?.includes(itemId)) {
      setSelectedItems(selectedItems.filter((selectedItem) => selectedItem !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
    }
  };

  const handleSelectAll = (checked) => {
    const allItemIds = locations?.map((item) => item.id);
    setSelectedItems(checked ? allItemIds : []);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={5}>
        <div
          style={{
            border: '1px solid #005974',
            borderRadius: 3,
            height: 249,
            overflowY: 'auto',
            paddingTop: 0,
          }}
        >
          <div
            className='s-normal'
            style={{
              padding: 15,
              background: '#F0F0F0',
              borderBottom: '2px solid #fff',
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            {t("Business Units")} <span style={{ color: 'red' }}>{" *"}</span>
          </div>
          {dataObj === 'Yes' && (
            <List style={{ padding: 0 }}>
            {sortedOptionList?.map((option) => (
              <ListItem
                key={option}
                className='s-normal'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '5px 10px',
                }}
              >
                <Checkbox
                  className='location-check'
                  id={option}
                  disabled={true}
                  checked={true}
                  onChange={() => handleOptionClick(option)}
                />
                <label htmlFor={option} style={{ marginLeft: 8 }}>
                  {option}
                </label>
              </ListItem>
            ))}
          </List>
          )}
          {dataObj === 'No' && (
            <List style={{ padding: 0 }}>
            {sortedOptionList?.map((option) => (
              <ListItem
                key={option}
                className='s-normal'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '5px 10px',
                }}
              >
                <Checkbox
                  className='location-check'
                  id={option}
                  checked={ selectedOptions?.includes(option) }
                  disabled={isBUser && selectedItems.length > 1 ? true : false}
                  onChange={() => handleOptionClick(option)}
                />
                <label htmlFor={option} style={{ marginLeft: 8 }}>
                  {option}
                </label>
              </ListItem>
            ))}
          </List>
          )}
        </div>
      </Grid>
      <Grid item xs={7}>
        <div
          style={{
            border: '1px solid #005974',
            borderRadius: 3,
            height: 249,
            overflowY: 'auto',
            paddingTop: 0,
          }}
        >
          <div
            className='s-normal'
            style={{
              padding: 15,
              background: '#F0F0F0',
              borderBottom: '2px solid #fff',
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            
            {t("Locations")} <span style={{ color: 'red' }}>{" *"}</span>
          </div>
          {dataObj === 'Yes' && (
            <List style={{ padding: 0 }}>
              {/* <ListItem style={{ padding: 0 }}>
                  <Checkbox
                  className='location-check'
                  id='All'
                  // disabled={isDisabled}
                  checked={true}
                />
                <label style={{ marginLeft: 8 }}>
                All
                </label>
              </ListItem> */}
            {locations.map((location) => (
              <ListItem key={location.id} style={{ padding: 0 }}>
                <Checkbox
                  className='location-check'
                  id={location.id}
                  disabled={true}
                  checked={true}
                  onChange={() => handleToggleSelect(location.id)}
                />
                <label htmlFor={location.id} style={{ marginLeft: 8 }}>
                  {location.locationName}
                </label>
              </ListItem>
            ))}
          </List>
          )}
          {dataObj === 'No' && (
            <List style={{ padding: 0 }}>
              {/* <ListItem style={{ padding: 0 }}>
                <Checkbox
                className='location-check'
                id='All'
                disabled={isBUser ? true : isDisabled}
                checked={isDisabled ? true : selectedItems?.length === locations?.length && locations?.length > 0}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
              <label style={{ marginLeft: 8 }}>
              All
                </label>
              </ListItem> */}
            {locations?.map((location) => (
              <ListItem key={location.id} style={{ padding: 0 }}>
                <Checkbox
                  className='location-check'
                  id={location.id}
                  disabled={isBUser && selectedItems.length > 1 ? true : isBUser && selectedItems.length === 1 && !selectedItems.includes(location.id) ? true : isDisabled}
                  checked={isDisabled ? true : selectedItems?.includes(location.id)}
                  onChange={() => handleToggleSelect(location.id)}
                />
                <label htmlFor={location.id} style={{ marginLeft: 8 }}>
                  {location.locationName}
                </label>
              </ListItem>
            ))}
          </List>
          )}
          
        </div>
      </Grid>
    </Grid>
  );
};

export default BusinessUnitLocationMapping;
